import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"

interface SizeProps {
  size?: number
}
interface PositionProps extends SizeProps {
  bgColor: string
}

export const Position = styled(Flex)<PositionProps>`
  width: ${({size}) => size || 32}px;
  height: ${({size}) => size || 32}px;
  border-radius: 100%;
  background-color: ${({bgColor}) => bgColor};
  position: absolute;
  ${({left}) => left && `left: ${left};`}
`

export const ImageWrapper = styled.div<SizeProps>`
  width: ${({size}) => size || 100}px;
  height: ${({size}) => size || 100}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  overflow: hidden;
  margin: 0 auto;
  box-shadow: ${({theme}) => theme.shadows.low};
`

export const Image = styled.img`
  border-radius: 100%;
`

export const Wrapper = styled.div<SizeProps>`
  position: relative;
  width: ${({size}) => size || 100}px;
  margin: 0 auto;
`
